import { DocumentData } from "@angular/fire/firestore";
import { FormGroup } from "@angular/forms";
import { HoursOfOperation } from "../../hours.model";

enum CategoryExceptionState {
  None,
  Create,
  Edit,
  Duplicate
}
export class CategoryException {
  public hours: HoursOfOperation;
  public day: string;
  public state: CategoryExceptionState;

  constructor(day: string) {
    this.day = day;
    this.default();
  }

  compare(b: CategoryException): boolean {
    return (
      this.hours.begin == b.hours.begin &&
      this.hours.end == b.hours.end &&
      this.day == b.day
    );
  }

  default() {
    this.hours = new HoursOfOperation();
  }

  load(data: DocumentData) {
    this.hours = new HoursOfOperation().load(data.hours);
    return this;
  }

  toJSON() {
    return {
      day: this.day,
      hours: this.hours.toJSON()
    };
  }

  create(form: any) {
    this.hours = new HoursOfOperation().set(form.hours);
  }

  edit(category: CategoryException) {
    this.hours = new HoursOfOperation().edit(category.hours);
    return this;
  }

  public timeframe(): string {
    return this.hours.toString();
  }
}
